export default {
  filter: 'h-[42px] px-[12px] flex items-center align-center rounded-lg border-[1px] border-[#CEDCEC] font-interMedium text-[14px] text-[#70747E] gap-2 cursor-pointer hover:brightness-90',
  active: 'bg-[#E7ECF2]',
};
